import React, { useState } from 'react';

function Switch({ on, onClick }) {
  return <span className="switch" data-on={on} onClick={onClick} />;
}

export default function ConfigPage({ user }) {
  const [section, setSection]   = useState('general');
  const [autoMode, setAutoMode] = useState(true);
  const [alerts, setAlerts]     = useState(true);
  const [sound, setSound]       = useState(false);
  const [safety, setSafety]     = useState(true);
  const [name, setName]         = useState(
    user?.displayName?.split(' ')[0] || localStorage.getItem('mee_name') || 'Matias'
  );

  const NAV = [
    ['general',  'General'],
    ['engine',   'Motor de señales'],
    ['alerts',   'Alertas'],
    ['data',     'Fuentes de datos'],
    ['account',  'Cuenta'],
    ['shortcuts','Atajos'],
  ];

  return (
    <div className="page">
      <div style={{ marginBottom: 20 }}>
        <h1 className="page-title">Configuración</h1>
        <div className="page-sub">ajusta el motor · v1.6 MatiEdgePro · licencia Elite</div>
      </div>

      <div className="config-shell">
        {/* Nav lateral */}
        <div className="config-nav">
          {NAV.map(([k, l]) => (
            <button key={k} data-active={section === k} onClick={() => setSection(k)}>
              {l}
            </button>
          ))}
        </div>

        {/* Contenido */}
        <div className="config-section">

          {/* ── GENERAL ── */}
          {section === 'general' && <>
            <div className="config-group">
              <h3>Apariencia</h3>
              <div className="hint">cómo se ve Edge Elite en tu pantalla</div>
              <div className="config-row">
                <div>
                  <div className="t">Densidad</div>
                  <div className="d">Espacio entre filas de la tabla.</div>
                </div>
                <select className="select" defaultValue="comoda">
                  <option>Compacta</option>
                  <option>Cómoda</option>
                  <option>Amplia</option>
                </select>
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Idioma</div>
                  <div className="d">Idioma de la interfaz.</div>
                </div>
                <select className="select" defaultValue="es">
                  <option value="es">Español</option>
                  <option value="en">English</option>
                </select>
              </div>
            </div>

            <div className="config-group">
              <h3>Modo de operación</h3>
              <div className="config-row">
                <div>
                  <div className="t">Modo AUTO</div>
                  <div className="d">El motor toma tick cada 7 segundos y emite veredictos.</div>
                </div>
                <Switch on={autoMode} onClick={() => setAutoMode(!autoMode)} />
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Reconectar al arrancar</div>
                  <div className="d">Retoma la sesión anterior automáticamente.</div>
                </div>
                <Switch on={true} />
              </div>
            </div>
          </>}

          {/* ── MOTOR DE SEÑALES ── */}
          {section === 'engine' && <>
            <div className="config-group">
              <h3>Umbrales del veredicto</h3>
              <div className="hint">cuándo marcar ENTRAR vs VIGILAR vs ESPERAR</div>
              <div className="config-row">
                <div>
                  <div className="t">Ventaja mínima para ENTRAR</div>
                  <div className="d">Diferencia en puntos entre modelo y línea.</div>
                </div>
                <input className="input" type="number" defaultValue="7.0" step="0.1" />
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Confianza mínima para ENTRAR</div>
                  <div className="d">Score del motor 0–10.</div>
                </div>
                <input className="input" type="number" defaultValue="6.5" step="0.1" />
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Minuto mínimo de muestra</div>
                  <div className="d">Evitar señal con muestra corta (en segundos).</div>
                </div>
                <input className="input" type="number" defaultValue="110" />
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Excluir garbage time</div>
                  <div className="d">Ignora posesiones con diferencial &gt; 25 pts en Q4.</div>
                </div>
                <Switch on={safety} onClick={() => setSafety(!safety)} />
              </div>
            </div>
            <div className="config-group">
              <h3>Ponderaciones del modelo</h3>
              <div className="config-row">
                <div>
                  <div className="t">Pace</div>
                  <div className="d">Peso del ritmo posesional en la proyección.</div>
                </div>
                <input className="input" type="number" defaultValue="0.35" step="0.05" />
              </div>
              <div className="config-row">
                <div>
                  <div className="t">eFG% combinado</div>
                  <div className="d">Peso del efficient FG.</div>
                </div>
                <input className="input" type="number" defaultValue="0.40" step="0.05" />
              </div>
              <div className="config-row">
                <div>
                  <div className="t">TO rate</div>
                  <div className="d">Peso de pérdidas de balón.</div>
                </div>
                <input className="input" type="number" defaultValue="0.15" step="0.05" />
              </div>
            </div>
          </>}

          {/* ── ALERTAS ── */}
          {section === 'alerts' && (
            <div className="config-group">
              <h3>Notificaciones</h3>
              <div className="config-row">
                <div>
                  <div className="t">Avisar cuando se abra un ENTRAR</div>
                  <div className="d">Push del sistema + banner en la app.</div>
                </div>
                <Switch on={alerts} onClick={() => setAlerts(!alerts)} />
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Sonido</div>
                  <div className="d">Reproducir campana en picks de confianza ≥ 7.</div>
                </div>
                <Switch on={sound} onClick={() => setSound(!sound)} />
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Resumen diario</div>
                  <div className="d">Notificación a las 23:30 con el P&amp;L del día.</div>
                </div>
                <Switch on={true} />
              </div>
            </div>
          )}

          {/* ── FUENTES DE DATOS ── */}
          {section === 'data' && (
            <div className="config-group">
              <h3>Fuentes de datos</h3>
              <div className="config-row">
                <div>
                  <div className="t">Proveedor de odds</div>
                  <div className="d">Conexión principal para líneas O/U. BetsAPI prioridad.</div>
                </div>
                <select className="select">
                  <option>BetsAPI · Bet365</option>
                  <option>odds-api.io · fallback</option>
                  <option>Manual</option>
                </select>
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Proveedor de partidos</div>
                  <div className="d">Feed de play-by-play live.</div>
                </div>
                <select className="select">
                  <option>APS Ultra · 75k req/día</option>
                  <option>ESPN</option>
                </select>
              </div>
              <div className="config-row">
                <div>
                  <div className="t">API Key odds-api</div>
                  <div className="d">••••••••••••  · vence según plan</div>
                </div>
                <button className="btn">Rotar</button>
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Ligas monitoreadas</div>
                  <div className="d">Cobertura global activa.</div>
                </div>
                <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink)' }}>25+</span>
              </div>
            </div>
          )}

          {/* ── CUENTA ── */}
          {section === 'account' && (
            <div className="config-group">
              <h3>Cuenta</h3>
              <div className="config-row">
                <div>
                  <div className="t">Nombre</div>
                  <div className="d">Se muestra en el dashboard.</div>
                </div>
                <input
                  className="input"
                  value={name}
                  onChange={e => { setName(e.target.value); localStorage.setItem('mee_name', e.target.value); }}
                />
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Plan</div>
                  <div className="d">Elite · licencia activa</div>
                </div>
                <button className="btn btn-primary">Administrar</button>
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Firebase</div>
                  <div className="d">mati-edge-elite-default-rtdb</div>
                </div>
                <span style={{ fontSize: 11, color: 'var(--pos)', fontWeight: 600 }}>Conectado</span>
              </div>
              <div className="config-row">
                <div>
                  <div className="t">Software</div>
                  <div className="d">Versión activa del motor</div>
                </div>
                <span style={{ fontSize: 12, color: 'var(--ink-2)', fontWeight: 500 }}>V1.6 MatiEdgePro</span>
              </div>
            </div>
          )}

          {/* ── ATAJOS ── */}
          {section === 'shortcuts' && (
            <div className="config-group">
              <h3>Atajos de teclado</h3>
              <div className="config-row">
                <div><div className="t">Ir al dashboard</div></div>
                <span><span className="kbd">G</span> <span className="kbd">D</span></span>
              </div>
              <div className="config-row">
                <div><div className="t">Abrir Performance Lab</div></div>
                <span><span className="kbd">G</span> <span className="kbd">L</span></span>
              </div>
              <div className="config-row">
                <div><div className="t">Abrir Configuración</div></div>
                <span><span className="kbd">G</span> <span className="kbd">C</span></span>
              </div>
              <div className="config-row">
                <div><div className="t">Toggle tema claro/oscuro</div></div>
                <span><span className="kbd">⌘</span> <span className="kbd">.</span></span>
              </div>
              <div className="config-row">
                <div><div className="t">Buscar partido</div></div>
                <span><span className="kbd">/</span></span>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
